import { useMemo } from "react";

const DashboardStatCard = ({
  title,
  value,
  subtitle,
  variant = "default",
  progress = 0,
  progressPercent,
  progressTotal,
}) => {
  const percent = Math.max(
    0,
    Math.min(
      100,
      progressPercent ??
        (progressTotal ? (Number(value) / Math.max(1, progressTotal)) * 100 : progress)
    )
  );

  const titleLines = useMemo(() => {
    const parts = String(title || "").trim().split(/\s+/);
    if (parts.length <= 2) return [parts.join(" ")];
    return [parts.slice(0, 2).join(" "), parts.slice(2).join(" ")];
  }, [title]);

  const renderTitle = (extraClasses = "") => (
   <p
      className={`text-[12px] font-medium tracking-wide uppercase text-center leading-tight text-(--neutral-700) ${extraClasses}`}
    >
      {titleLines.map((line, idx) => (
        <span key={idx} className="block">
          {line}
        </span>
      ))}
    </p>
  );

  if (variant === "progress") {
     return (
      <div className="rounded-lg p-3 h-[150px] w-full max-w-[150px]  flex-col items-center justify-center">
        <div className="text-sm flex flex-col items-center justify-center h-full gap-1">
          {renderTitle("")}
          <div className="relative w-20 h-20">
          <svg className="w-full h-full transform -rotate-90">
            <circle cx="40" cy="40" r="36" stroke="#F5F5F5" strokeWidth="7" fill="none" />
              <circle
                cx="40"
                cy="40"
                r="36"
                stroke="#35C758"
                strokeWidth="7"
                fill="none"
                strokeDasharray={`${2 * Math.PI * 36}`}
                strokeDashoffset={`${2 * Math.PI * 36  * (1 - percent / 100)}`}
                strokeLinecap="round"
                className="transition-all duration-500"
              />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <div className="font-body text-3xl font-bold text-(--neutral-900)">{value}</div>
            </div>
          </div>
          <div className="text-sm text-(--neutral-700) text-center whitespace-nowrap">
            {subtitle}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-lg h-[150px] w-[150px]">
      <div className="mb-2">{renderTitle("text-(--neutral-700)")}</div>
      <h2 className="text-center my-6">{value}</h2>
      <div className="text-base text-center text-(--neutral-700) whitespace-nowrap font-body">
        {subtitle}
      </div>
    </div>
  );
};

export default DashboardStatCard;